"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Tooltip_1 = require("@material-ui/core/Tooltip");
var textTooltipStyles_1 = require("./textTooltipStyles");
var TextTooltip = function (_a) {
    var text = _a.text, content = _a.content, _b = _a.placement, placement = _b === void 0 ? 'top-end' : _b, id = _a.id;
    var styles = textTooltipStyles_1.default();
    return (<Tooltip_1.default placement={placement} title={text} data-test={"text:tooltip:" + (id !== null && id !== void 0 ? id : '')} enterTouchDelay={0} leaveTouchDelay={5000} arrow={true} classes={{
        arrow: styles.tooltipArrow,
        tooltip: styles.tooltip,
    }}>
      {content}
    </Tooltip_1.default>);
};
exports.default = TextTooltip;
